import React from 'react';
import { format } from 'timeago.js';

import './tweetauthor.scss';

export default ({ user = {}, created, config }) => {
  return (
    <div className="tweet-author">
      <img className="tweet-author__profile" src={user.profile_image} />
      <div className="tweet-author__details">
        <div className="tweet-author__name" style={{ color: config.name_color }}>
          {user.name}
        </div>
        <div className="tweet-author__screen-name" style={{ color: config.username_color }}>
          @{user.screen_name}
        </div>
        {!['split-screen-animated', 'split-screen-no-animation'].includes(config.style) && (
          <div className="tweet-author__created" style={{ color: config.date_color }}>
            {format(created)}
          </div>
        )}
      </div>
    </div>
  );
};
